import React from 'react';
import { showEmeraldDialog } from 'src/common/components/interactive-dialogue/components/interactive-dialog-content/interactive-dialog-content';
import { EmeraldDialogTypes } from 'src/common/enumerations/emerald-dialog-types';
import { styles } from './device-styles';
import { useTranslation } from 'react-i18next';

export interface ScaleErrorMessageProps {
  retry?: () => void;
  cancel: () => void;
  errorTitleId: string;
  itemId: string;
  itemDescription: string;
  errorMessageId: string;
}

export const scaleErrorMessage = (scaleErrorMessageProps: ScaleErrorMessageProps): void => {
  showEmeraldDialog({
    message: scaleErrorMessageProps.errorTitleId,
    type: EmeraldDialogTypes.Error,
    subMessage: [
      <ScaleErrorMessage
        key={'scaleErrorMsg'}
        itemId={scaleErrorMessageProps.itemId}
        itemDescription={scaleErrorMessageProps.itemDescription}
        message={scaleErrorMessageProps.errorMessageId}
      />,
    ],
    onCancel: scaleErrorMessageProps.cancel,
    closeButtonLabel: 'GoBack',
    onAccept: scaleErrorMessageProps.retry,
    acceptButtonLabel: 'CheckScanner_Retry',
    hideCancelButton: false,
  });
};

const ScaleErrorMessage: React.FC<Props> = (props: Props): JSX.Element => {
  const { itemId, itemDescription, message } = props;
  const { t } = useTranslation();
  const classes = styles();
  return (
    <>
      <p
        data-testid='scale-error-message-item-description'
        className={`${classes.mainErrorMsg} ${classes.bottomErrorMsg}`}
      >
        {itemId} {itemDescription}
      </p>
      <p data-testid='scale-error-message' className={classes.mainErrorMsg}>
        {t(message)}
      </p>
    </>
  );
};
interface Props {
  itemId: string;
  itemDescription: string;
  message: string;
}

export default ScaleErrorMessage;
